import { ArrivalAndDepartureInput } from '../../lib/types/models/arrival-and-departure/arrival-and-departure-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createArrivalAndDeparture(
  input: ArrivalAndDepartureInput & { coachCompanyId?: number }
) {
  return restApiClient.url(constructApiUrl(API.arrivalAndDeparture.create.url, null)).post(input)
}
